export function PostBerg_isset(arr, var_args) {
  for (var i = 1, k = arguments.length; i < k; ++i) {
    if (!arr || !arr.hasOwnProperty(arguments[i])) return false;
    arr = arr[arguments[i]];
  }
  return true;
}

export function PostBerg_mapOrder(array, order, key) {
  array.sort(function(a, b) {
    var A = a[key],
      B = b[key];

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1;
    } else {
      return -1;
    }
  });

  return array;
}

export function PostBerg_Color(number_of_color = 999) {
  let original_colors = [
    { name: 'light-grayish-magenta', hex: '#d0a5db' },
    { name: 'pale-pink', hex: '#f78da7' },
    { name: 'vivid-red', hex: '#cf2e2e' },
    { name: 'luminous-vivid-amber', hex: '#fcb900' },
    { name: 'vivid-cyan-blue', hex: '#0693e3' },
    { name: 'vivid-cyan-turquoise', hex: '#00BCD4' },
    { name: 'vivid-cyan-green', hex: '#00C853' },
    { name: 'very-light-gray', hex: '#eee' },
    { name: 'vivid-white', hex: '#fff' },
    { name: 'very-dark-gray', hex: '#444' },
    { name: 'very-dark-blue', hex: '#37474F' },

  ];

  let return_colors = [];
  original_colors.forEach(color => {
    return_colors.push({
      name: color.name,
      color: color.hex,
      slug: color.name.toLowerCase()
    });
  });

  if (number_of_color < 999) {
    return return_colors.slice(0, number_of_color);
  }

  return return_colors;
}

export function PostBerg_GoogleFontLoader(font) {
  let fetchStyle = function(url) {
    return new Promise((resolve, reject) => {
      let link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.onload = function() {
        resolve();
      };
      link.href = url;

      let headScript = document.querySelector('script');
      headScript.parentNode.insertBefore(link, headScript);
    });
  };

  if (font == 'Theme Default') return false;
  if (font == 'Arial') return false;

  if (!PostBerg.google_fonts.includes(font)) {
    fetchStyle(`https://fonts.googleapis.com/css?family=` + font.replace(' ', '+'));
    PostBerg.google_fonts.push(font);
  }
}



// WEBPACK FOOTER //
// ./src/js/utils.js